<div *ngIf="open" class="confirmation-modal bulk-delete-preview-overlay">
    <div class="modal-content bulk-delete-preview-dialog">
        <div class="modal-header bulk-delete-preview-header">
            <i class="bi bi-exclamation-triangle warning-icon" aria-hidden="true"></i>
            <h3>{{ title }}</h3>
        </div>

        <div class="modal-body bulk-delete-preview-body">
            <p *ngIf="selectedCount != null" class="bulk-delete-selected-summary">
                <strong>{{ selectedLabel }}:</strong>
                <span class="bulk-delete-selected-count">{{ selectedCount }}</span>
            </p>

            <div class="bulk-delete-impact-grid"
                 [class.bulk-delete-impact-grid--single]="!(willDelete.length) || !(relatedRetained.length)">
                <section *ngIf="willDelete.length" class="bulk-delete-impact-panel bulk-delete-impact-panel--danger"
                         aria-labelledby="bulk-delete-will-delete-heading">
                    <header class="bulk-delete-impact-panel__header">
                        <i class="bi bi-trash3-fill" aria-hidden="true"></i>
                        <h4 id="bulk-delete-will-delete-heading">{{ willDeleteTitle }}</h4>
                    </header>
                    <ul class="bulk-delete-impact-list">
                        <li *ngFor="let item of willDelete">
                            <span class="bulk-delete-impact-label">{{ item.label }}</span>
                            <span class="bulk-delete-impact-count">{{ item.count }}</span>
                        </li>
                    </ul>
                </section>

                <section *ngIf="relatedRetained.length"
                         class="bulk-delete-impact-panel bulk-delete-impact-panel--safe"
                         aria-labelledby="bulk-delete-retained-heading">
                    <header class="bulk-delete-impact-panel__header">
                        <i class="bi bi-shield-check" aria-hidden="true"></i>
                        <h4 id="bulk-delete-retained-heading">{{ retainedTitle }}</h4>
                    </header>
                    <ul class="bulk-delete-impact-list">
                        <li *ngFor="let item of relatedRetained">
                            <span class="bulk-delete-impact-label">{{ item.label }}</span>
                            <span class="bulk-delete-impact-count">{{ item.count }}</span>
                        </li>
                    </ul>
                </section>
            </div>

            <div *ngIf="assurances.length" class="bulk-delete-assurances">
                <p *ngFor="let line of assurances" class="bulk-delete-assurance-line">
                    <span class="bulk-delete-assurance-mark" aria-hidden="true">✓</span>
                    <span>{{ line }}</span>
                </p>
                <p *ngIf="footerMessage" class="bulk-delete-footer-message">{{ footerMessage }}</p>
            </div>

            <p *ngIf="!assurances.length && note" class="bulk-delete-note">{{ note }}</p>
        </div>

        <div class="modal-footer bulk-delete-preview-footer">
            <button type="button" class="confirm-btn modal-red" [disabled]="confirming" (click)="onConfirm()">
                {{ confirming ? 'Deleting...' : confirmLabel }}
            </button>
            <button type="button" class="cancel-btn cancel-btn-green" [disabled]="confirming" (click)="onCancel()">
                Cancel
            </button>
        </div>
    </div>
</div>
